/**
 * 主观题答案 (填空/简答)
 */
import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import {
    BaseQuestionType,
    getRightOption,
    getStuAnswer,
    OptionsItem
} from "service/exercise";

interface StuAnswerObjProps {
    score: string;
    stuScore: number;
    stuIsRight: string;
    stuAns: string;
    options: OptionsItem[];
    queTypeId: number;
}

export default function StuAnswerObj({
    score,
    stuScore,
    stuIsRight,
    stuAns,
    options,
    queTypeId
}: StuAnswerObjProps) {
    const [stuAnswer, setStuAnswer] = useState<any>();
    const [rightOption, setRightOption] = useState<string[]>();

    useEffect(() => {
        const answer = getStuAnswer(queTypeId, stuAns, options);
        setStuAnswer(answer);

        const right = getRightOption(queTypeId, options);
        setRightOption(right);
    }, [queTypeId, stuAns, options]);

    return (
        <div className={style.root}>
            <div className={style.body}>
                <div className={style.answer}>
                    学生答案
                    {/* 学生答案 均为字符串，单选判断为选项id,多选为选项id数组打印出的字符串,主观题为学生答案,填空题为答案json串*/}
                    {stuAns && queTypeId === BaseQuestionType.Fill && (
                        <>
                            <span
                                className={classNames(style.span, {
                                    [style.correct]: stuIsRight === "1",
                                    [style.wrong]: stuIsRight === "0"
                                })}
                            />
                            <div
                                className={style.fullAnswer}
                                style={{ color: "#666", marginBottom: "10px" }}>
                                {options.map((item, index) => (
                                    <div key={item.id}>
                                        填空 {index + 1}：{" "}
                                        {stuAnswer?.[`answer${index + 1}`]}
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                    {stuAns && queTypeId !== BaseQuestionType.Fill && (
                        <span
                            className={classNames(style.span, {
                                [style.correct]: stuIsRight === "1",
                                [style.wrong]: stuIsRight === "0"
                            })}>
                            {stuAnswer}
                        </span>
                    )}
                    {!stuAns && (
                        <span
                            className={classNames(
                                style.span,
                                style.wrong,
                                style.empty
                            )}>
                            尚未作答
                        </span>
                    )}
                </div>

                <div className={style.score}>
                    本题得分
                    <span className={style.span}>
                        <em>{stuScore ? stuScore : "0"}</em> 分
                    </span>
                    <span className={classNames(style.span, style.totalScore)}>
                        （本题{score}分）
                    </span>
                </div>
            </div>

            <div className={style.footer}>
                正确答案
                <div className={style.span}>{rightOption}</div>
                {queTypeId === BaseQuestionType.Fill && (
                    <div className={style.fullAnswer}>
                        {options.map((item, index) => (
                            <div key={item.id}>
                                填空 {index + 1}：{item.description}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
